import { makeAutoObservable } from 'mobx';
import type { RootStore } from './root-store';

export class SymbolDetailFairPriceDialogStore {
    rootStore: RootStore;

    fairPriceDialogOpened = false;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeAutoObservable(this, {
            rootStore: false,
        });
    }

    openFairPriceDialog(): void {
        this.fairPriceDialogOpened = true;
    }

    closeFairPriceDialog(): void {
        this.fairPriceDialogOpened = false;
    }
}
